import React from 'react';
import { ICell as Cell } from 'models/interfaces/spreadsheet-types/core-types';
import {
  MEAN_ALIAS,
  MEDIAN_ALIAS,
  PERCENTILE_25,
  PERCENTILE_75,
  PERCENTILE_SELECTION_A_ALIAS,
  PERCENTILE_SELECTION_B_ALIAS,
  SELECTED_MULTIPLE,
  SELECTED_MULTIPLE_VALUE,
  SEVENTY_FIFTH_ALIAS,
  SPECIFIED_LABEL,
  TWENTY_FIFTH_ALIAS,
} from 'pages/Valuations/approaches/guidelinePublicCompanies/constants';
import { percentileOptions } from 'pages/Valuations/approaches/guidelinePublicCompanies/gpc/config/getRowConfig';

function selectionChange<T extends Omit<Cell, 'dependencies' | 'options' | 'providers' | 'sheet'>>(
  cells: { [key: string]: T },
  changes: { cell: T; value: string | number | null | undefined }[],
  cell: T,
  value: string | number | null | undefined,
  useMultiplePremiumDiscount = false,
  selectionUpdates: { [key: string]: number } = {}
) {
  let selectionA = percentileOptions[(cells.TITLES_percentile_selection_a.value as number) - 1];
  let selectionB = percentileOptions[(cells.TITLES_percentile_selection_b.value as number) - 1];
  if ('percentile_selection_a' in selectionUpdates) {
    selectionA = percentileOptions[selectionUpdates.percentile_selection_a - 1];
  }
  if ('percentile_selection_b' in selectionUpdates) {
    selectionB = percentileOptions[selectionUpdates.percentile_selection_b - 1];
  }
  const selectionMap = {
    Mean: MEAN_ALIAS,
    Median: MEDIAN_ALIAS,
    [SPECIFIED_LABEL]: SELECTED_MULTIPLE,
    [PERCENTILE_75]: SEVENTY_FIFTH_ALIAS,
    [PERCENTILE_25]: TWENTY_FIFTH_ALIAS,
    [selectionA?.label]: PERCENTILE_SELECTION_A_ALIAS,
    [selectionB?.label]: PERCENTILE_SELECTION_B_ALIAS,
  };

  const appliedMultipleCell = Object.values(cells).find(
    cellParam => cellParam.alias === SELECTED_MULTIPLE_VALUE && cellParam.columnId === cell.columnId
  ) as T;
  const mpdExpr = useMultiplePremiumDiscount ? ` * (1 + ${cell.columnId}_MPD)` : '';
  changes.push({
    cell: appliedMultipleCell,
    value: `=${cell.columnId}_${selectionMap[value as string]}${mpdExpr}`,
  });
}

export default selectionChange;
